/*
 *  -----------------------------------------------------------------------
 *    <copyright file="my-account.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import parsePhoneNumber from 'libphonenumber-js';

import './styles.scss';
import { useTranslation } from 'hooks';
import { OrganisationMemberFields } from 'queries/generated/fragments.generated';
import Constants from 'utils/constants';

const MyAccount = ({ user, organisationMember }: { user: any; organisationMember: OrganisationMemberFields }) => {
    const { t } = useTranslation();

    const getLevel = (systemAdminLevel: number) => {
        let level = '';
        const systemLevels: any = Constants.SystemAdminLevel;
        for (const key in systemLevels) {
            if (systemAdminLevel === systemLevels[key]) {
                level = key;
                return t(`uam:${level}`);
            }
        }
        return level;
    };

    const phoneNumber = user.phone ? (parsePhoneNumber(`+${user.phone}`)?.formatInternational() ?? '') : '';

    return (
        <div className="my-profile-wrapper">
            <div className="d-flex">
                <div className="account-data-wrap">
                    <div className="account-row">
                        <div>
                            <span className="account-title">
                                <strong>{t('common:name')}:</strong>
                            </span>
                            <span className="account-value">
                                {user.firstName} {user.lastName}
                            </span>
                        </div>
                    </div>
                    <div className="account-row">
                        <div>
                            <span className="account-title">
                                <strong>{t('uam:email')}:</strong>
                            </span>
                            <span className="account-value">{user.email}</span>
                        </div>
                    </div>
                    {user.systemAdminLevel <= 0 ? (
                        <div className="account-row">
                            <span className="account-title">
                                <strong>{t('uam:userAdministrator')}:</strong>
                            </span>
                            <span className="account-value">
                                {organisationMember?.isAdmin ? t('common:yes') : t('common:no')}
                            </span>
                        </div>
                    ) : null}
                </div>
                <div className="account-data-wrap">
                    {user.systemAdminLevel > 0 ? (
                        <div className="account-row">
                            <span className="account-title">
                                <strong>{t('level')}:</strong>
                            </span>
                            <span className="account-value">{getLevel(user.systemAdminLevel)}</span>
                        </div>
                    ) : (
                        <div className="account-row">
                            <span className="account-title">
                                <strong>{t('uam:role')}:</strong>
                            </span>
                            <span className="account-value">{user.role?.name ?? ''}</span>
                        </div>
                    )}
                    <div className="account-row">
                        <div>
                            <span className="account-title">
                                <strong>{t('uam:mobileCellNumber')}:</strong>
                            </span>
                            <span className="account-value">{phoneNumber}</span>
                        </div>
                    </div>
                    {user.systemAdminLevel <= 0 ? (
                        <div className="account-row">
                            <span className="account-title">
                                <strong>{t('uam:auditLogAccess')}:</strong>
                            </span>
                            <span className="account-value">
                                {user.isAuditAdmin() ? t('common:yes') : t('common:no')}
                            </span>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default MyAccount;
